import React, { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import { logoutUser } from "../../actions/authActions";
import { useAlert } from "react-alert";
import { useDispatch } from "react-redux";
import { localAssetUrl } from "../../utils/assets";

const SIDEBAR_LOGO = localAssetUrl("assets/img/logo.png");

const NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: "fas fa-th-large", exact: true },
  { to: "/profile", label: "My Account", icon: "fas fa-user", exact: false },
  { to: "/saved-subjects", label: "Registered Subjects", icon: "fas fa-book-open", exact: true },
  { to: "/my-subscriptions", label: "Subscriptions", icon: "fas fa-credit-card", exact: true },
  { to: "/results", label: "Results", icon: "fas fa-clipboard-list", exact: true },
  { to: "/mock-score", label: "Mock Performance", icon: "fas fa-chart-bar", exact: true },
  { to: "/account-setting", label: "Account Setting", icon: "fas fa-cog", exact: true },
];

const UserLeftSide = () => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const logoutHandler = () => {
    dispatch(logoutUser());
    alert.success("Logout successfully.");
  };

  return (
    <Fragment>
      <aside className="student-sidebar">
        <div className="student-sidebar__brand">
          <Link to="/dashboard" className="student-sidebar__brand-link">
            <img src={SIDEBAR_LOGO} alt="ONE TIME SUCCESS" className="student-sidebar__logo" />
          </Link>
        </div>

        <nav className="student-sidebar__nav" aria-label="Student portal navigation">
          <ul className="student-sidebar__menu">
            {NAV_ITEMS.map((item) => (
              <li key={item.to} className="student-sidebar__menu-item">
                <NavLink
                  to={item.to}
                  exact={item.exact}
                  className="student-sidebar__link"
                  activeClassName="is-active"
                >
                  <span className="student-sidebar__icon">
                    <i className={item.icon} aria-hidden="true" />
                  </span>
                  <span className="student-sidebar__label">{item.label}</span>
                  <span className="student-sidebar__chevron" aria-hidden="true">
                    <i className="fas fa-chevron-right" />
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="student-sidebar__footer">
          <button type="button" className="student-sidebar__link student-sidebar__logout" onClick={logoutHandler}>
            <span className="student-sidebar__icon">
              <i className="fas fa-sign-out-alt" aria-hidden="true" />
            </span>
            <span className="student-sidebar__label">Log Out</span>
            <span className="student-sidebar__chevron student-sidebar__chevron--empty" aria-hidden="true" />
          </button>
        </div>
      </aside>
    </Fragment>
  );
};

export default UserLeftSide;
